import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const clearAuthStorage = useCallback(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_profile");
    localStorage.removeItem("authActiveTab");
    localStorage.removeItem("rememberedUsername");
  }, []);

  /*
  =============================
  TAB CLOSE LOGOUT
  =============================
  */
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem("tabClosing", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  /*
  =============================
  LOGOUT
  =============================
  */
  const logout = useCallback(() => {
    console.log("🔐 User logged out");

    window.dispatchEvent(new CustomEvent("userLogout"));

    clearAuthStorage();
    setUser(null);
  }, [clearAuthStorage]);

  /*
  =============================
  LOAD USER ON APP START
  =============================
  */
  useEffect(() => {
    const loadUser = async () => {
    const token = localStorage.getItem("access_token");

    if (token) {
        try {
            const cachedProfile = localStorage.getItem("user_profile");

            if (cachedProfile) {
                console.log("✅ Using cached profile");
                setUser(JSON.parse(cachedProfile));
            }

            // This request will automatically refresh the access token if needed
            const res = await api.get("users/user/profile/");

            localStorage.setItem("user_profile", JSON.stringify(res.data));
            setUser(res.data);

            console.log("✅ Profile loaded");
        } catch (err) {
            console.error("❌ Failed to fetch profile", err);
            logout();
        }
    }
    else {
        console.log("⚠️ No access token found");
    }

    setLoading(false);
    };

    loadUser();
  }, [logout]);

  /*
  =============================
  LOGIN
  =============================
  */
  const login = useCallback((profile, access, refresh) => {
    console.log("✅ User logged in");

    localStorage.setItem("access_token", access);
    localStorage.setItem("refresh_token", refresh);
    localStorage.setItem("user_profile", JSON.stringify(profile));

    setUser(profile);

    window.dispatchEvent(new CustomEvent("userLogin"));
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};